export const getAllShiftPaisaConfigurations = `
query {
  allShiftPaisaConfigurations {
    id
    name
    employeeType
    category
    isActive
    mustNotBeLate
    minOtBeyondShiftMinutes
  }
}`;

export const getShiftPaisaConfigurationById = `
query($id: ID!) {
  shiftPaisaConfigurationById(id: $id) {
    id
    name
    employeeType
    category
    isActive
    mustNotBeLate
    minOtBeyondShiftMinutes
  }
}`;

export const createShiftPaisaConfigurationMutation = `
mutation CreateShiftPaisaConfiguration(
  $name: String!
  $employeeType: String
  $category: String
  $isActive: Boolean
  $mustNotBeLate: Boolean
  $minOtBeyondShiftMinutes: Int
) {
  createShiftPaisaConfiguration(
    name: $name
    employeeType: $employeeType
    category: $category
    isActive: $isActive
    mustNotBeLate: $mustNotBeLate
    minOtBeyondShiftMinutes: $minOtBeyondShiftMinutes
  ) {
    success
    message
    shiftPaisaConfiguration {
      id
      name
    }
  }
}`;

export const updateShiftPaisaConfigurationMutation = `
mutation UpdateShiftPaisaConfiguration(
  $id: ID!
  $name: String
  $employeeType: String
  $category: String
  $isActive: Boolean
  $mustNotBeLate: Boolean
  $minOtBeyondShiftMinutes: Int
) {
  updateShiftPaisaConfiguration(
    id: $id
    name: $name
    employeeType: $employeeType
    category: $category
    isActive: $isActive
    mustNotBeLate: $mustNotBeLate
    minOtBeyondShiftMinutes: $minOtBeyondShiftMinutes
  ) {
    success
    message
    shiftPaisaConfiguration {
      id
      name
    }
  }
}`;

export const deleteShiftPaisaConfigurationMutation = `
mutation DeleteShiftPaisaConfiguration($id: ID!) {
  deleteShiftPaisaConfiguration(id: $id) {
    success
    message
  }
}`;

export const employeeTypeOptionapi = `
query {
  allEmployeeTypes {
    id
    employeetype
  }
}`;

export const allCategoriesQuery = `
query {
  allCategories
}`;
